import { defineComponent as _defineComponent } from 'vue'
import useProfileState from '@/state/profile/profileState';
import { computed } from 'vue';
import { ProjectPreferences } from '@/models/Profile';
import useI18n from '@/mixins/useI18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfilePreferencesView',
  setup(__props) {

const { profile } = useProfileState();
const { t } = useI18n();

const companySizeObject = computed(() => t('profile.projectPreferences.companySizeOptions') as unknown as Record<string, string>);
const remoteWorkObject = computed(() => t('profile.projectPreferences.remoteWorkOptions') as unknown as Record<string, string>);
const microProjectObject = computed(() => t('profile.projectPreferences.microProjectOptions') as unknown as Record<string, string>);

const preferences = computed(() => profile.value?.projectPreferences as ProjectPreferences);

const location = computed(() => {
  const p = preferences.value;
  if (!p?.country) return '';
  return `${p.placeName ? `${p.placeName}, ` : ''}${p.country}${p.radiusInKm ? ` (+${p.radiusInKm}km)` : ''}`;
});

return { __sfc: true,profile, t, companySizeObject, remoteWorkObject, microProjectObject, preferences, location }
}

})